var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcticonSparkleFill16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "octicon:sparkle-fill-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2958 1.92295C11.3484 1.77816 11.4442 1.65307 11.5703 1.56466C11.6965 1.47626 11.8468 1.42883 12.0008 1.42883C12.1548 1.42883 12.3051 1.47626 12.4313 1.56466C12.5574 1.65307 12.6533 1.77816 12.7058 1.92295L13.4228 3.88195C13.9851 5.41769 14.8755 6.81236 16.032 7.9688C17.1884 9.12524 18.5831 10.0156 20.1188 10.578L22.0763 11.295C22.2211 11.3475 22.3462 11.4434 22.4346 11.5695C22.523 11.6956 22.5704 11.8459 22.5704 12C22.5704 12.154 22.523 12.3043 22.4346 12.4304C22.3462 12.5565 22.2211 12.6524 22.0763 12.705L20.1188 13.422C18.5831 13.9843 17.1884 14.8747 16.032 16.0311C14.8755 17.1875 13.9851 18.5822 13.4228 20.118L12.7058 22.0755C12.6533 22.2202 12.5574 22.3453 12.4313 22.4337C12.3051 22.5221 12.1548 22.5696 12.0008 22.5696C11.8468 22.5696 11.6965 22.5221 11.5703 22.4337C11.4442 22.3453 11.3484 22.2202 11.2958 22.0755L10.5788 20.118C10.0165 18.5822 9.12609 17.1875 7.96966 16.0311C6.81322 14.8747 5.41855 13.9843 3.88281 13.422L1.92381 12.705C1.77902 12.6524 1.65392 12.5565 1.56552 12.4304C1.47711 12.3043 1.42969 12.154 1.42969 12C1.42969 11.8459 1.47711 11.6956 1.56552 11.5695C1.65392 11.4434 1.77902 11.3475 1.92381 11.295L3.88281 10.578C5.41855 10.0156 6.81322 9.12524 7.96966 7.9688C9.12609 6.81236 10.0165 5.41769 10.5788 3.88195L11.2958 1.92295Z",
    fill: "#7033FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcticonSparkleFill16);
export default __webpack_public_path__ + "static/media/octicon_sparkle-fill-16.b6be4fcdc3398fcb0de79770b641820f.svg";
export { ForwardRef as ReactComponent };